// extracted by mini-css-extract-plugin
export default {"element":"NothingFound_element__9GTRz"};